import React from 'react';
import { Card, Typography, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function NoteRulesEmptyState({ onAddRule }) {
  const { t } = useTranslation();

  return (
    <Card
      data-testid="empty-state"
      style={{
        padding: "20px",
      }}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <InboxOutlined style={{ fontSize: "48px", color: "#bfbfbf", marginBottom: "16px", display: "block" }} />
          <Text type="secondary" style={{ display: "block" }}>
            {t('note_rules.empty_state')}
          </Text>
        </div>
      </Space>
    </Card>
  );
} 